import React from "react";
import LightSvg from "../svg/LightSvg";
import "./cardLabel.scss";
const CardLabel = ({ live, like }) => {
  return (
    <div className="card_labels">
      {live ? <span className="card_label red_color">LIVE</span> : null}
      <span className="card_label">
        <LightSvg />
        {like}
      </span>
    </div>
  );
};
CardLabel.defaultProps = {
  like: "0",
};
export default CardLabel;
